import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/dave/checkouts/pyohio/static-website/node_modules/gatsby-theme-catalyst-core/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Seo = makeShortcode("Seo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Seo title="Volunteer for PyOhio" mdxType="Seo" />
    <h1 {...{
      "id": "volunteer-for-pyohio"
    }}>{`Volunteer for PyOhio`}</h1>
    <p>{`Would you like to help with a future PyOhio event?`}</p>
    <p><a parentName="p" {...{
        "href": "https://docs.google.com/forms/d/e/1FAIpQLSd1KiDUUDDqzIH7tMV0OeeDPGZZZEwPSBt0yTtqA8hIyj14Bw/viewform?usp=sf_link",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`Sign up here to volunteer!`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      